import { useMemo } from "react";
import { useApiClient } from "@louise/api/louise-api";
import { usePatient } from "@louise/patients/hooks/usePatient";
import { useStytchUser } from "@louise/api/useStytch";

function compactRecord(
  record: Record<string, string | undefined>,
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(record).filter(([, value]) => Boolean(value)),
  ) as Record<string, string>;
}

export function useChatwootIdentity() {
  const { data: patient, isLoading: isPatientLoading } = usePatient();
  const { tenantId, patientId } = useApiClient();
  const { user: stytchUser } = useStytchUser();
  const stytchUserId = stytchUser?.user_id ?? "";

  return useMemo(() => {
    const name = patient?.firstName ?? "";
    const email = patient?.email ?? "";
    const phone = patient?.phoneNumber ?? "";
    const identifier = stytchUserId;
    const user = compactRecord({
      name: name || undefined,
      email: email || undefined,
    });

    return {
      identifier,
      isPatientLoading,
      user,
      customAttributes: compactRecord({
        louiseApp: "moon",
        louiseStytchUserId: stytchUserId || undefined,
        louisePatientId: patient?.id ?? patientId ?? undefined,
        louiseTenantId: tenantId ?? undefined,
        louiseEmail: email || undefined,
        louiseFirstName: name || undefined,
        louisePhone: phone || undefined,
      }),
    };
  }, [
    patient?.email,
    patient?.firstName,
    patient?.id,
    patient?.phoneNumber,
    patientId,
    stytchUserId,
    tenantId,
    isPatientLoading,
  ]);
}
